// src/store/slices/contactSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import contactApi from 'api/contactApi';

// export const fetchContacts = createAsyncThunk(
//   'contact/fetchContacts',
//   async ({ page = 1, pageSize = 10, search = '', is_active }, { rejectWithValue }) => {
//     try {
//       const response = await contactApi.getAll(page, pageSize, search, is_active);
//       return response;
//     } catch (err) {
//       const msg = err.response?.data?.detail || 'Failed to load contacts';
//       return rejectWithValue(msg);
//     }
//   }
// );


export const fetchContacts = createAsyncThunk(
  'contact/fetchContacts',
  async (
    { page = 1, pageSize = 10, search = '', is_active = null, created_by = null,       label = null  }, 
    { rejectWithValue }
  ) => {
    try {
      // Pass created_by as 5th param to API
      const response = await contactApi.getAll(page, pageSize, search, is_active, created_by, label);
      return response;
    } catch (err) {
      const msg = err.response?.data?.detail || 'Failed to load contacts';
      return rejectWithValue(msg);
    }
  }
);

export const createContact = createAsyncThunk(
  'contact/createContact',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await contactApi.create(formData);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || { detail: 'Failed to create contact' });
    }
  }
);

export const updateContact = createAsyncThunk(
  'contact/updateContact',
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const response = await contactApi.update(id, payload);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || { detail: 'Failed to update contact' });
    }
  }
);

export const deleteContact = createAsyncThunk(
  'contact/deleteContact',
  async (id, { rejectWithValue }) => {
    try {
      await contactApi.delete(id);
      return id;
    } catch (err) {
      const msg = err.response?.data?.detail || 'Failed to delete contact';
      return rejectWithValue(msg);
    }
  }
);

export const exportContacts = createAsyncThunk(
  'contact/exportContacts',
  async (_, { rejectWithValue }) => {
    try {
      const blob = await contactApi.exportCsv();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `contacts_${new Date().toISOString().slice(0, 10)}.csv`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      return rejectWithValue('Export failed');
    }
  }
);

export const importPreview = createAsyncThunk(
  'contact/importPreview',
  async (file, { rejectWithValue }) => {
    try {
      const data = await contactApi.importPreview(file);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || 'Preview failed');
    }
  }
);

export const importConfirm = createAsyncThunk(
  'contact/importConfirm',
  async (preview, { rejectWithValue, dispatch }) => {
    try {
      await contactApi.importConfirm(preview);
      dispatch(fetchContacts({ page: 1, pageSize: 10 }));
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || 'Import failed');
    }
  }
);

const contactSlice = createSlice({
  name: 'contact',
  initialState: {
    contacts: [],
    pagination: { next: null, previous: null, count: 0, page_size: 10 },
    isLoading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchContacts.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchContacts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.contacts = action.payload.data;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchContacts.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(createContact.fulfilled, (state, action) => {
        state.contacts.unshift(action.payload);
        state.pagination.count += 1;
      })
      .addCase(updateContact.fulfilled, (state, action) => {
        const idx = state.contacts.findIndex(c => c.id === action.payload.id);
        if (idx !== -1) state.contacts[idx] = action.payload;
      })
      .addCase(deleteContact.fulfilled, (state, action) => {
        state.contacts = state.contacts.filter(c => c.id !== action.payload);
        state.pagination.count -= 1;
      })
      .addCase(exportContacts.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(importPreview.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(importPreview.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(importPreview.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(importConfirm.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(importConfirm.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(importConfirm.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = contactSlice.actions;
export default contactSlice.reducer;